// components/DynamicModal.tsx
import React from "react";
import { Modal } from "antd";
import "./ModalPopup.css";

interface DynamicModalProps {
  title: string;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  okText?: string;
  cancelText?: string;
  width?: number | string;
  children: React.ReactNode;
  centered?: boolean;
  destroyOnClose?: boolean;
}

const ModalPopup: React.FC<DynamicModalProps> = ({
  title,
  open,
  onOk,
  onCancel,
  okText = "OK",
  cancelText = "Cancel",
  width = 600,
  children,
  centered = true,
  destroyOnClose = true,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      width={width}
      centered={centered}
      destroyOnClose={destroyOnClose}
      footer={false}
    >
      {children}
    </Modal>
  );
};

export default ModalPopup;
